module.exports = __webpack_public_path__ + "static/media/citoso v1 .c15d9201.glb";